import { useMemo, useState } from 'react'
import Locale, { localeContext } from '@saima/common/i18n'

/** Supported ISO 639-1 language codes */
const staffPointLanguages = ['en', 'fi']
const languages = staffPointLanguages
const LocaleContext = localeContext

function parseLanguage (lang) {
  return lang ? lang.split('-')[0] : null
}

export function detectLanguage () {
  // Always prefer localStorage first
  let lang = window.localStorage.getItem('lang')
  if (languages.includes(lang)) return lang

  // Then check navigator language
  lang = parseLanguage(navigator.language)
  if (languages.includes(lang)) return lang

  // Internet explorer includes lang code in different place
  lang = parseLanguage(navigator.userLanguage)
  if (languages.includes(lang)) return lang

  return 'en'
}

const i18nSettings = {
  fallbackLng: languages[0],
  nsSeparator: false,
  react: {
    useSuspense: false
  }
}
export const LocaleProvider = ({ children }) => {
  const [lang, setLang] = useState(detectLanguage())
  const localeObject = new Locale(lang, setLang, { talentPoint: true }, i18nSettings)
  const localeMemo = useMemo(() => localeObject, [localeObject])
  return (
    <LocaleContext value={localeMemo}>{children}</LocaleContext>
  )
}
